import CountUp from "react-countup";
import { useInView } from "framer-motion";
import { useRef } from "react";
import { useTranslation } from "react-i18next";

const STATS = [
    { end: 99, suffix: "%", key: "satisfaction" as const },
    { end: 7, suffix: "+", key: "years" as const },
    { end: 45, suffix: "+", key: "projects" as const },
    { end: 102, suffix: "+", key: "clients" as const },
];

const StatsStrip = () => {
    const { t } = useTranslation();
    const ref = useRef<HTMLDivElement>(null);
    const inView = useInView(ref, { once: true, margin: "-80px" });

    return (
        <section className="py-20">
            <div className="container mx-auto px-6">
                <div ref={ref} className="grid grid-cols-2 lg:grid-cols-4 gap-10 md:gap-12">
                    {STATS.map((s) => (
                        <div key={s.key} className="text-center">
                            <p className="font-v2-display text-white text-5xl md:text-7xl lg:text-8xl mb-2">
                                {inView ? (
                                    <CountUp
                                        end={s.end}
                                        duration={1.8}
                                        useEasing
                                        suffix={s.suffix}
                                    />
                                ) : (
                                    <span>0{s.suffix}</span>
                                )}
                            </p>
                            <p className="font-v2-label text-[11px] md:text-xs text-white/50">
                                {t(`stats_strip.${s.key}`)}
                            </p>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default StatsStrip;
